import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-settings-container" }
const _hoisted_2 = { class: "content-area" }
const _hoisted_3 = { class: "column gap-2 top_bottom_padding border-bottom" }
const _hoisted_4 = { class: "color-light" }
const _hoisted_5 = { class: "row top_bottom_padding" }
const _hoisted_6 = { class: "color-light" }
const _hoisted_7 = { class: "padding-r-2" }
const _hoisted_8 = { class: "confirmation-section" }
const _hoisted_9 = { class: "modal-content-wrapper" }

import FormButton from '@/components/common/button/FormButton.vue';
import FloatingCard from '@/components/common/floating-card/FloatingCard.vue';
import CustomModal from '@/components/common/modal/CustomModal.vue';
import NavHeader from '@/components/common/nav-header/NavHeader.vue';
import FormSelect from '@/components/common/select/FormSelect.vue';
import UserIndexSettings from '@/components/UserSettings/UserIndexSettings.vue';
import RouteNames from '@/configuration/router/names.routes';
import { IndexIdentifiers, RagIndex } from '@/core/indexesEnum';
import navigationService from '@/services/NavigationService';
import { useAuthStore } from '@/stores/authStore';
import { useUserSettingsStore } from '@/stores/userSettingsStore';
import { useToasterStore } from '@/stores/useToasterStore';
import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { onBeforeRouteLeave } from 'vue-router';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserSettingsView',
  setup(__props) {

const { t } = useI18n();
const settingsStore = useUserSettingsStore();
const toasterStore = useToasterStore();
const { products } = useAuthStore();

const selectedRagIndex = ref(String(settingsStore.selectedRagIndex));
const originalRagIndex = ref(String(settingsStore.selectedRagIndex));
const showLeaveModal = ref(false);
const pendingNavigation = ref<(() => void) | null>(null);

function sortByLabelPriority(arr: { label: string; value: string }[]) {
  const labelOrder = [
    IndexIdentifiers[RagIndex.NAW],
    IndexIdentifiers[RagIndex.ECAY],
    IndexIdentifiers[RagIndex.CissContable],
    IndexIdentifiers[RagIndex.CissFiscal],
    IndexIdentifiers[RagIndex.CissLaboral],
    IndexIdentifiers[RagIndex.LamylineNew],
    IndexIdentifiers[RagIndex.LamylineNotarie],
    IndexIdentifiers[RagIndex.LiaisonsNotarie]
  ];
  return arr.sort(
    (a, b) => labelOrder.indexOf(a.label) - labelOrder.indexOf(b.label)
  );
}

settingsStore.initializeData();

onMounted(() => {
  selectedRagIndex.value =
    settingsStore.selectedRagIndex !== undefined
      ? String(settingsStore.selectedRagIndex)
      : '';
  originalRagIndex.value =
    settingsStore.selectedRagIndex !== undefined
      ? String(settingsStore.selectedRagIndex)
      : '';
});

onBeforeUnmount(() => {
  settingsStore.persist();
});

const hasChanges = computed(() => {
  return selectedRagIndex.value !== originalRagIndex.value;
});

const availableIndexes = computed(() => {
  return sortByLabelPriority(
    products.availableIndexes.map((x) => ({
      value: String(x),
      label: IndexIdentifiers[x]
    }))
  );
});

onBeforeRouteLeave((to, from, next) => {
  if (hasChanges.value) {
    showLeaveModal.value = true;
    pendingNavigation.value = () => next();
    next(false);
  } else {
    next();
  }
});

const confirmChanges = async (): Promise<void> => {
  if (!hasChanges.value) {
    navigationService.navigateTo({ name: RouteNames.Home });
    return;
  }

  const newIndex = selectedRagIndex.value;

  if (newIndex === '') {
    toasterStore.error({
      title: t('user_settings.error_saving_title'),
      body: t('user_settings.error_saving_no_source_message')
    });
    return;
  }

  const ragIndexToSave = Number(newIndex) as RagIndex;
  settingsStore.setSelectedRagIndex(ragIndexToSave);

  originalRagIndex.value = newIndex;

  toasterStore.success({
    title: t('user_settings.changes_saved_title'),
    body: t('user_settings.changes_saved_message')
  });

  navigationService.navigateTo({ name: RouteNames.Home });
};

const confirmLeave = (): void => {
  showLeaveModal.value = false;
  selectedRagIndex.value = originalRagIndex.value;
  navigationService.navigateTo({ name: RouteNames.Home });
};

const cancelLeave = (): void => {
  showLeaveModal.value = false;
  pendingNavigation.value = null;
};

const handleLeaveModalClose = (): void => {
  cancelLeave();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(NavHeader),
      _createVNode(FloatingCard, { "with-shadow": false }, {
        default: _withCtx(() => [
          _createElementVNode("h5", null, _toDisplayString(_ctx.$t('user_settings.general_settings')), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('user_settings.source')), 1),
            _createVNode(FormSelect, {
              placeHolder: _ctx.$t('user_settings.source'),
              options: availableIndexes.value,
              modelValue: selectedRagIndex.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedRagIndex).value = $event)),
              disabled: !availableIndexes.value.length
            }, null, 8, ["placeHolder", "options", "modelValue", "disabled"])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('user_settings.language')), 1),
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('user_settings.language.identifier')), 1)
          ])
        ]),
        _: 1
      }),
      false
        ? (_openBlock(), _createBlock(UserIndexSettings, { key: 0 }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(FormButton, {
        label: _ctx.$t('user_settings.confirm_changes'),
        type: "primary",
        onClick: confirmChanges,
        "class-name": "w-100"
      }, null, 8, ["label"])
    ]),
    _createVNode(CustomModal, {
      show: showLeaveModal.value,
      "onUpdate:show": _cache[1] || (_cache[1] = (val) => (showLeaveModal.value = val)),
      onClose: handleLeaveModalClose
    }, {
      "left-button": _withCtx(() => [
        _createVNode(FormButton, {
          label: _ctx.$t('user_settings.continue'),
          type: "primary",
          onClick: confirmLeave
        }, null, 8, ["label"])
      ]),
      "right-button": _withCtx(() => [
        _createVNode(FormButton, {
          label: _ctx.$t('user_settings.cancel'),
          type: "secondary",
          onClick: cancelLeave
        }, null, 8, ["label"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("h6", null, _toDisplayString(_ctx.$t('user_settings.unsaved_changes_title')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('user_settings.unsaved_changes_message')), 1)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}
}

})